import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

type Props = {
  open: boolean
  onClose: () => void
}

export const PrivacyPolicyDialog = ({ open, onClose }: Props) => {
  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>
        プライバシーポリシー
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>内容</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" fullWidth onClick={onClose}>
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  )
}
